import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({ stats }) => (
  <footer className="footer" data-testid="footer">
    <div className="footer-tagline">&ldquo;No bias scores. No trust ratings. Just visibility.&rdquo;</div>
    <div className="footer-links">
      <Link to="/methodology">Methodology</Link>
      <Link to="/sources">Sources</Link>
      <Link to="/privacy">Privacy</Link>
    </div>
    <div className="footer-stats">
      {stats ? `${stats.total_sources || 20} sources · ${stats.total_articles || 0} articles · ${stats.total_clusters || 0} stories` : 'Loading...'}
    </div>
  </footer>
);

export default Footer;
